import { TagERP, TagType } from "@finanedi.es/storybook"
import { GetFacturasAceptablesDtoProps } from "api/DTOs/GetFacturasAceptablesDto"
import { GetPagaresAceptablesDtoProps } from "api/DTOs/GetPagaresAceptablesDto"
import { ESTADO_VERIFICACION_EFECTO } from "api/Types/EstadoVerificacionEfecto"
import { t } from "i18next"

export const EstadoFinanciacionActual = ({
  estado,
  id,
}: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps) => {
  if (estado === null || estado === undefined) return
  const ESTADO_REVISION_PROPERTIES: Record<
    number,
    {
      color: TagType
      text: string
    }
  > = {
    [ESTADO_VERIFICACION_EFECTO.PENDIENTE]: {
      color: "alternativeOne",
      text: t("validaciones.status.pendingLabel"),
    },
    [ESTADO_VERIFICACION_EFECTO.COMUNICADO]: {
      color: "alternativeOne",
      text: t("validaciones.status.pendingLabel"),
    },
    [ESTADO_VERIFICACION_EFECTO.NO_VERIFICADO]: {
      color: "danger",
      text: t("validaciones.status.rejectedLabel"),
    },
    [ESTADO_VERIFICACION_EFECTO.VERIFICADO]: {
      color: "success",
      text: t("validaciones.status.validateLabel"),
    },
    [ESTADO_VERIFICACION_EFECTO.GENERANDO_EVIDENCIA]: {
      color: "info",
      text: t("validaciones.status.generatingEvidence"),
    },
  }

  const { color, text } = ESTADO_REVISION_PROPERTIES[estado] || {}

  return (
    <TagERP
      id={id}
      value={text}
      color={color ?? "alternativeOne"}
    />
  )
}
